import api from './api';

export interface LessonPackageDto {
  id: string;
  name: string;
  description?: string;
  priceCents: number;
  currencyCode: string;
  lessonsPerPeriod?: number;
  lessonDurationMinutes: number;
  billingType: 'one_time' | 'subscription';
  isActive: boolean;
  billingLinked?: boolean;
  billingWarning?: string;
  applyPriceChangeToExisting: boolean;
  sortOrder: number;
  activeSubscriberCount: number;
}

export type UpsertLessonPackageRequest = Omit<
  LessonPackageDto,
  'id' | 'activeSubscriberCount'
>;

export const packagesService = {
  async list(): Promise<LessonPackageDto[]> {
    const res = await api.get<LessonPackageDto[]>('/teacher/lesson-packages');
    return res.data;
  },

  async create(body: UpsertLessonPackageRequest): Promise<LessonPackageDto> {
    const res = await api.post<LessonPackageDto>('/teacher/lesson-packages', body);
    return res.data;
  },

  async update(id: string, body: UpsertLessonPackageRequest): Promise<LessonPackageDto> {
    const res = await api.put<LessonPackageDto>(`/teacher/lesson-packages/${id}`, body);
    return res.data;
  },

  async deactivate(id: string): Promise<void> {
    await api.delete(`/teacher/lesson-packages/${id}`);
  },
};
